import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";

import { ListItemText } from "@mui/material";
import { useDocumentTitle } from "../../Hooks/useDocumentTitle";
import { Footer } from "../../Components/Footer";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

export default function AboutUs() {
  useDocumentTitle("O Nas");

  return (
    <>
      <CssBaseline />
      <main>
        <Box
          sx={{
            bgcolor: "background.paper",
            pt: 8,
            pb: 6,
          }}
        >
          <Container maxWidth="sm">
            <Typography
              component="h1"
              variant="h3"
              align="center"
              color="text.primary"
            >
              Nasza Działalność
            </Typography>
          </Container>
        </Box>
        <Container sx={{ py: 8 }} maxWidth="md">
          <Grid container spacing={4}>
            <Typography variant="h6" gutterBottom>
              Micree prowadzi działania badawczo-rozwojowe w zakresie
              kształcenia zawodowego oraz transferu wiedzy i innowacji z
              wykorzystaniem zasobów kapitału intelektualnego.
            </Typography>
            <Typography variant="h6" gutterBottom>
              GŁÓWNE ZADANIA Micree:
            </Typography>
            <List>
              <ListItem>
                <ListItemText primary="monitorowanie potrzeb światowego rynku pracy, tendencji i zmian na nim zachodzących," />
              </ListItem>
              <ListItem>
                <ListItemText primary="monitorowanie zapotrzebowania na nowe zawody i kwalifikacje," />
              </ListItem>
              <ListItem>
                <ListItemText primary="określanie kwalifikacji dla nowopowstałych zawodów," />
              </ListItem>
              <ListItem>
                <ListItemText primary="testowanie i implementacja nowych rozwiązań w zakresie kształcenia zawodowego," />
              </ListItem>
              <ListItem>
                <ListItemText primary="wskazywanie kierunków i metod kształcenia zawodowego w systemie pozaformalnym i nieformalnym," />
              </ListItem>
              <ListItem>
                <ListItemText primary="certyfikowanie kwalifikacji w sposób ujednolicony, zgodny z krajowymi i unijnymi wytycznymi w tym zakresie," />
              </ListItem>
              <ListItem>
                <ListItemText primary="promocja mobilności zawodowej pracowników," />
              </ListItem>
              <ListItem>
                <ListItemText primary="promocja uczenia się przez całe życie." />
              </ListItem>
            </List>
          </Grid>
        </Container>
      </main>
      <Footer />
    </>
  );
}
